import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import "../style.scss";
import Loading from '../../../components/Loading/Index'
import Requests from '../../../utils/Requests/Index'
import ProfileDetails from '../../../components/SingleProfile/ProfileDetails/Index'
import PartnerPreference from '../../../components/SingleProfile/PartnerPreference/Index';
import Profile from "../../../components/Profile/Index"
import { singleProContext } from '../../../utils/context/SingleProfileContext';
import { io } from "socket.io-client";
import Icon from 'react-icons-kit'
import { chevronLeft, chevronRight, user, heart } from 'react-icons-kit/feather'
import 'react-toastify/dist/ReactToastify.css'
import { useSelector } from 'react-redux'
// toast.configure({ autoClose: 2000 });

const Index = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const { ids } = useContext(singleProContext);
    const [key, setKey] = useState("details");
    const [data, setData] = useState({});
    const [isLoading, setLoading] = useState(true);
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    const socket = useRef()
    const userInfo = useSelector((state) => state.user.userData)

    // Fetch data
    const fetchData = useCallback(async () => {
        setLoading(true)
        const response = await Requests.MyProfile.Single_Profile(id, header)
        if (response && response.user) setData(response.user)
        setLoading(false)
    }, [header, id]);

    useEffect(() => {
        fetchData()
    }, [header, fetchData, id]);

    useEffect(() => {
        socket.current = io(`${process.env.REACT_APP_API_URL}`, { transports: ["websocket", 'polling'] })
    }, [])

    useEffect(() => {
        if (!isLoading) {
            socket.current.emit("profileViewed", {
                id: userInfo.userID,
                name: userInfo.name,
                image: userInfo.profilePicture,
                to: id
            })
        }
    }, [id, isLoading, userInfo])

    // Profile prev & next Function..
    const profileIds = ids || [];
    const currentIndex = profileIds.indexOf(id);
    const hasPrev = currentIndex > 0;
    const hasNext = currentIndex > -1 && currentIndex < profileIds.length - 1;

    const prevProfile = () => {
        if (hasPrev) navigate(`/single-profile/${profileIds[currentIndex - 1]}`)
    };
    const nextProfile = () => {
        if (hasNext) navigate(`/single-profile/${profileIds[currentIndex + 1]}`)
    };

    if (isLoading) return <Loading />

    const hasAddsense = Boolean(data.addsense)

    return (
        <div className="single_profile">
            <div className="container">

                {/* Top bar */}
                <div className="sp-topbar">
                    <Link to="/matches/all" className="sp-back">
                        <Icon icon={chevronLeft} size={16} /> All Matches
                    </Link>

                    <div className="sp-nav">
                        <button
                            type="button"
                            disabled={!hasPrev}
                            onClick={prevProfile}
                        >
                            <Icon icon={chevronLeft} size={16} /> Prev
                        </button>
                        <button
                            type="button"
                            disabled={!hasNext}
                            onClick={nextProfile}
                        >
                            Next <Icon icon={chevronRight} size={16} />
                        </button>
                    </div>
                </div>

                {/* Profile summary */}
                <Profile item={data} variant="single" />

                <div className="row sp-body">
                    <div className={hasAddsense ? "col-12 col-xl-8" : "col-12"}>

                        {/* Tabs */}
                        <div className="sp-tabs">
                            <button
                                type="button"
                                className={key === 'details' ? "active" : ""}
                                onClick={() => setKey('details')}
                            >
                                <Icon icon={user} size={15} /> Profile Details
                            </button>
                            <button
                                type="button"
                                className={key === 'partner' ? "active" : ""}
                                onClick={() => setKey('partner')}
                            >
                                <Icon icon={heart} size={15} /> Partner Preference
                            </button>
                        </div>

                        <div className="sp-panel">
                            {key === 'details'
                                ? <ProfileDetails data={data} />
                                : <PartnerPreference data={data} />
                            }
                        </div>
                    </div>

                    {/* Adds sense */}
                    {hasAddsense ?
                        <div className="col-12 col-xl-4">
                            <div className="sp-ads">
                                <img className="img-fluid" src={data.addsense} alt="addsense" />
                            </div>
                        </div>
                        : null}

                </div>
            </div>
        </div>
    );
};

export default Index;
